export default __webpack_public_path__ + "static/media/ddsu5168_qr_code.6e30c3ef.jpg";